export default function (value, greater_percentage) {
  if(greater_percentage<=0){
    return 0;
  }
  const percentage = (value * 100) / greater_percentage;
  return Number(percentage < 1 && percentage > 0 ? 1 : percentage.toFixed(2));
}
